export default "__VITE_ASSET__K0LORP9g__"